import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface MetricTileProps {
  icon: LucideIcon;
  iconColor: string;
  title: string;
  value: string | number;
  helper?: string;
  testId?: string;
  className?: string;
  onClick?: () => void;
}

export function MetricTile({
  icon: Icon,
  iconColor,
  title,
  value,
  helper,
  testId,
  className,
  onClick,
}: MetricTileProps) {
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper
      className={cn(
        "bg-white rounded-xl shadow-sm border border-gray-100 p-4 md:p-5",
        onClick && "text-left w-full hover:border-blue-200 hover:shadow-md transition-all cursor-pointer",
        className
      )}
      data-testid={testId}
      onClick={onClick}
    >
      <div className="flex items-start gap-3">
        <div className={cn("p-2 rounded-lg bg-gray-50", iconColor)}>
          <Icon className="h-5 w-5 md:h-6 md:w-6" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-gray-600 mb-1">{title}</p>
          <p className="text-xl md:text-2xl font-bold text-gray-900">{value}</p>
          {helper && (
            <p className="text-xs text-gray-500 mt-1">{helper}</p>
          )}
        </div>
      </div>
    </Wrapper>
  );
}
